import { Component, Input } from '@angular/core';

@Component({
    selector: 'fi-abstract-state',
    template: ` <ui-view class="{{ containerClass || '' }}"></ui-view>`,
    standalone: false,
})
export class FiAbstractStateComponent {
    @Input() containerClass: string;
}
